export function MoneyCoinsSvgIcon() {
  return (
    <svg viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="44" height="44" rx="12" fill="#EEFCF2" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.6148 19.0105C22.0453 18.441 21.1219 18.441 20.5524 19.0105C19.9829 19.58 19.9829 20.5034 20.5524 21.0729C21.1219 21.6424 22.0453 21.6424 22.6148 21.0729C23.1843 20.5034 23.1843 19.58 22.6148 19.0105ZM19.6685 18.1266C20.7262 17.0689 22.441 17.0689 23.4987 18.1266C24.5563 19.1843 24.5563 20.8991 23.4987 21.9568C22.441 23.0144 20.7262 23.0144 19.6685 21.9568C18.6108 20.8991 18.6108 19.1843 19.6685 18.1266Z"
        fill="#0F9D44"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.042 16.2917C13.042 15.0257 14.0676 14 15.3337 14H27.8337C29.0997 14 30.1253 15.0257 30.1253 16.2917V22.8617C30.1253 23.2068 29.8455 23.4867 29.5003 23.4867C29.1551 23.4867 28.8753 23.2068 28.8753 22.8617V16.2917C28.8753 15.716 28.4093 15.25 27.8337 15.25H15.3337C14.758 15.25 14.292 15.716 14.292 16.2917V23.7917C14.292 24.3673 14.758 24.8333 15.3337 24.8333H22.2178C22.563 24.8333 22.8428 25.1132 22.8428 25.4583C22.8428 25.8035 22.563 26.0833 22.2178 26.0833H15.3337C14.0676 26.0833 13.042 25.0577 13.042 23.7917V16.2917Z"
        fill="#0F9D44"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.542 22.96C15.542 22.6148 15.8218 22.335 16.167 22.335H17.8337C18.1788 22.335 18.4587 22.6148 18.4587 22.96C18.4587 23.3052 18.1788 23.585 17.8337 23.585H16.167C15.8218 23.585 15.542 23.3052 15.542 22.96Z"
        fill="#0F9D44"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.7085 17.1267C24.7085 16.7815 24.9883 16.5017 25.3335 16.5017H27.0002C27.3453 16.5017 27.6252 16.7815 27.6252 17.1267C27.6252 17.4719 27.3453 17.7517 27.0002 17.7517H25.3335C24.9883 17.7517 24.7085 17.4719 24.7085 17.1267Z"
        fill="#0F9D44"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.4366 23.6568C25.4471 24.0018 25.176 24.29 24.8309 24.3006C23.6056 24.3379 22.6252 25.3366 22.6252 26.5667C22.6252 27.8223 23.6438 28.8408 24.8994 28.8408C25.8085 28.8408 26.591 28.3029 26.9545 27.5221C27.1001 27.2092 27.4719 27.0736 27.7848 27.2192C28.0978 27.3649 28.2334 27.7367 28.0877 28.0496C27.5295 29.2488 26.3187 30.0908 24.8994 30.0908C22.9534 30.0908 21.3752 28.5127 21.3752 26.5667C21.3752 24.6535 22.8999 23.1088 24.7929 23.0511C25.1379 23.0406 25.4261 23.3118 25.4366 23.6568Z"
        fill="#0F9D44"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.4343 22.6217C26.1787 22.6217 25.1602 23.6402 25.1602 24.8958C25.1602 26.1515 26.1787 27.17 27.4343 27.17C28.6907 27.17 29.7085 26.1516 29.7085 24.8958C29.7085 23.6401 28.6907 22.6217 27.4343 22.6217ZM23.9102 24.8958C23.9102 22.9498 25.4883 21.3717 27.4343 21.3717C29.3813 21.3717 30.9585 22.9499 30.9585 24.8958C30.9585 26.8417 29.3813 28.42 27.4343 28.42C25.4883 28.42 23.9102 26.8419 23.9102 24.8958Z"
        fill="#0F9D44"
      />
    </svg>
  );
}
